<script setup lang="ts">
/**
 * One icon from `icons.ts`, drawn in the colour of the text beside it.
 *
 * Decoration only — `aria-hidden`, no title — because every icon here sits
 * next to a word that already says what it means. An icon that is the ONLY
 * label of a control needs an `aria-label` on the control, not a title here.
 */
import { ICONS, type IconName } from "./icons";

withDefaults(defineProps<{ name: IconName; size?: number }>(), { size: 16 });
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <component :is="node[0]" v-for="(node, i) in ICONS[name]" :key="i" v-bind="node[1]" />
  </svg>
</template>
